import { Button, Menu, MenuButton, MenuItemOption, MenuList, MenuOptionGroup } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { Icon } from 'shared-components';
import { ApplicantOfferRequirementTaskStatus } from 'api-paths-cas';
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';

import {
  assessmentDropdownLabels,
  readableStatuses,
  statusSelectStyle,
  taskStatusConfig,
} from './requirement-rows/constants';

interface StatusMenuProps {
  status: ApplicantOfferRequirementTaskStatus;
  isDisabled?: boolean;
  fulfilmentData?: unknown;
  onStatusChange: (status: ApplicantOfferRequirementTaskStatus) => void;
}

export function StatusMenu({ status, isDisabled = false, onStatusChange }: StatusMenuProps): ReactElement {
  const statusStyleProps = statusSelectStyle[status];
  const statusIcon = taskStatusConfig[status]?.icon;

  const menuItems = (
    <MenuList>
      <MenuOptionGroup
        type="radio"
        value={status}
        onChange={value => onStatusChange(value as ApplicantOfferRequirementTaskStatus)}
      >
        <MenuItemOption value={ApplicantOfferRequirementTaskStatus.Assess}>
          {assessmentDropdownLabels[ApplicantOfferRequirementTaskStatus.Assess]}
        </MenuItemOption>
        <MenuItemOption value={ApplicantOfferRequirementTaskStatus.Satisfied}>
          {assessmentDropdownLabels[ApplicantOfferRequirementTaskStatus.Satisfied]}
        </MenuItemOption>
        <MenuItemOption value={ApplicantOfferRequirementTaskStatus.Provisional}>
          {assessmentDropdownLabels[ApplicantOfferRequirementTaskStatus.Provisional]}
        </MenuItemOption>
        <MenuItemOption value={ApplicantOfferRequirementTaskStatus.NotSatisfied}>
          {assessmentDropdownLabels[ApplicantOfferRequirementTaskStatus.NotSatisfied]}
        </MenuItemOption>
        <MenuItemOption value={ApplicantOfferRequirementTaskStatus.Exempt}>
          {assessmentDropdownLabels[ApplicantOfferRequirementTaskStatus.Exempt]}
        </MenuItemOption>
      </MenuOptionGroup>
    </MenuList>
  );

  return (
    <Menu placement="bottom-end">
      <MenuButton
        as={Button}
        isDisabled={isDisabled}
        leftIcon={statusIcon ? <Icon icon={statusIcon} className="colorful-icon" /> : undefined}
        rightIcon={<Icon icon={faAngleDown} />}
        variant={status === ApplicantOfferRequirementTaskStatus.Assess ? 'outline' : 'status'}
        size="sm"
        {...statusStyleProps}
      >
        {readableStatuses[status]}
      </MenuButton>
      {menuItems}
    </Menu>
  );
}
